<script setup lang="ts">
import { useTemplateRef } from "vue";

defineProps<{ fontSize: number; lines: string[] }>();

defineExpose({ element: () => rootRef.value });

const rootRef = useTemplateRef("root");
</script>

<template>
  <div ref="root" class="sticky-note-text-display" :style="{ fontSize: fontSize + '%' }">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-for="(line, index) in lines" :key="index" v-html="line" />
  </div>
</template>

<style lang="scss">
@use "@/styles/mixins/typography";

.sticky-note-text-display {
  overflow: hidden;
  white-space: pre;
  width: 100%;
  height: 100%;

  @include typography.medium("regular");

  & > div {
    min-height: 1lh; // empty lines should still have height of 1 line height
  }

  // stay clickable even when the sticky is locked
  a {
    pointer-events: auto;
  }
}
</style>
